<template>
  <div id="appHeader">
    <el-row class="appHeader">
      <el-col :span="12">
        <img class="logo-pic" :src="src" alt="" style="vertical-align: middle" />
        <span style="font-size: 24px; font-weight: 600; vertical-align: text-bottom">
          <span v-if="$isShowDdyb.indexOf('yb') == -1" style="
              display: inline-block;
              width: 10px;
              height: 4px;
              background-color: #fff;
              margin-right: 10px;
              vertical-align: middle;
            "></span>
          {{ linkMan }}
        </span>
        <div @click="goPXzl" style="
            display: inline-block;
            text-decoration: underline;
            letter-spacing: 2px;
            cursor: pointer;
            margin-left: 40px;
            font-size: 16px;
            line-height: 30px;
            vertical-align: middle;
          ">
          操作培训资料
        </div>
        <div v-if="isShowDdyb == 'yb'" style="display: inline-block;margin-left: 40px;font-size: 12px;line-height:24px;">
          作业区电话:&nbsp;&nbsp;023-40719118
        </div>
      </el-col>
      <el-col :span="12" class="right-info">
        <div class="marquee" style="margin-right: 10px" v-if="power('TK_USER_SHIP') || power('TK_USER_TRUCK')">
          <div class="marquee_box">
            <ul class="marquee_list" :class="{ marquee_top: animate }">
              <li v-for="(item, index) in marqueeList" @click="modelOpenHandle('newsDetail', true, item)"
                class="roll-class" v-html="item.txtContent"></li>
            </ul>
          </div>
        </div>
        <div style="cursor: pointer" @click="
          handleRouterPush({
            path: '/Home/SystemS/headerNews',
            name: '站内信',
          })
          " v-if="power('TK_USER_SHIP') || power('TK_USER_TRUCK')">
          <el-badge :value="newsTotal" class="item" style="margin-right: 30px">
            <img class="pic-notic" src="../../assets/img/notic.png" alt="" />
          </el-badge>
        </div>
        <div class="header-userInfo" v-if="$store.state.user.currentUser.name &&
          $store.state.user.currentUser.org.name
          ">
          <span>{{
            $store.state.user.currentUser.name &&
            $store.state.user.currentUser.org.name
          }}&ensp;</span>
        </div>
        <el-dropdown trigger="click" class="userCss">
          <span class="title">
            <img src="../../assets/img/i-user.png" alt="" />
            {{ $store.state.user.currentUser.userName
            }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item @click.native="downloadAnd">Android App下载</el-dropdown-item> -->
            <el-dropdown-item @click.native="changePwd">修改密码</el-dropdown-item>
            <el-dropdown-item @click.native="logout">注销</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>

      <el-dialog :visible.sync="showChange" width="600px" :modal="true" :close-on-click-modal="false"
        :show-close="showClose" :before-close="cancel" :modal-append-to-body="false">
        <el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="100px" class="demo-ruleForm">
          <el-form-item label="原密码" prop="oldPwd">
            <el-input type="password" v-model="ruleForm2.oldPwd" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="newPwd">
            <el-input type="password" v-model="ruleForm2.newPwd" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmNewPwd">
            <el-input type="password" v-model="ruleForm2.confirmNewPwd" auto-complete="off"></el-input>
          </el-form-item>
          <div class="changePwdScrb">
            <!-- <p>密码由大小写字母、数字、特殊字符组成，长度至少10位</p> -->
            <p>{{ remark }}</p>
          </div>
          <el-form-item>

            <el-button type="primary" @click.native="submitPwd('ruleForm2')">确定</el-button>
            <el-button @click="resetForm('ruleForm2')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>


      <!-- <el-dialog
        title="修改密码"
        :visible.sync="showChange"
        width="500px"
        :modal="false"
        :close-on-click-modal ="false"
        :before-close="cancel"
      >
        <el-form :model="password" label-width="80px" :rules="rules">
          <el-form-item label="原密码:" >
            <el-input
              :model="password.oldPwd"
              placeholder=""
              type="password"
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码:" prop="newPwd">
            <el-input
              :model="password.newPwd"
              placeholder=""
              type="password"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码:" prop="confirmNewPwd">
            <el-input
              :model="password.confirmNewPwd"
              placeholder=""
              type="password"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="pwdFoot">
          <el-button type="primary" @click.native="submitPwd">确定</el-button>
          <el-button type="primary" @click.native="cancel">取消</el-button>
        </div>
      </el-dialog> -->
    </el-row>
    <el-row>
      <el-col :span="24">
        <!-- <div class="tags-view-container"  :style="{'margin-left':menuIsCollapse?'64px':'200px'}"> -->
        <div class="tags-view-container" :class="{ 'tags-l': menuIsCollapse, 'tags-r': !menuIsCollapse }">
          <!-- <div class="history"> -->
          <!-- <el-scrollbar> -->
          <scroll-pane class="tags-view-wrapper" ref="scrollPane">
            <router-link ref="tag" class="tags-view-item" :class="isActive(tag) ? 'active' : ''"
              v-for="tag in Array.from(cachedViews)" :to="tag.path" :key="tag.path"
              @contextmenu.prevent.native="openMenu(tag, $event)">
              {{ tag.name }}
              <span class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)"></span>
            </router-link>
          </scroll-pane>
          <!-- </el-scrollbar> -->
          <ul class="contextmenu" v-show="visible" :style="{ left: left + 'px', top: top + 'px' }">
            <li @click="closeSelectedTag(selectedTag)">{{ "关闭当前页" }}</li>
            <li @click="closeOthersTags">{{ "关闭其他页面" }}</li>
            <li @click="closeAllTags">{{ "关闭所有" }}</li>
          </ul>
          <!-- </div> -->
        </div>
      </el-col>
    </el-row>
    <news-detail ref="newsDetail" @load="intervalMassage"></news-detail>

    <!-- 编辑弹出框
    <el-dialog title="编辑" :visible.sync="checkPwd" width="30%">
      <el-form ref="form" :model="form" label-width="50px">

        <el-form-item label="姓名">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="地址">
          <el-input v-model="form.address"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveEdit">确 定</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import { parametersCode } from "@/api/outCard/card";
import { out, updataPwd } from "@/api/auth/auth";
import { setLinkhis, getRollMessage } from "@/api/system/person";
import ScrollPane from "@/components/ScrollPane";
import newsDetail from "../business/system/newsDetail";
import { arrIsHave, isEmpty } from "@/utils/common";
export default {
  name: "appHeader",
  components: {
    ScrollPane,
    newsDetail,
  },
  data() {
    var checkOldPwd = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("不能为空"));
      }
      //   setTimeout(() => {
      //     if (!Number.isInteger(value)) {
      //       callback(new Error("请输入数字值"));
      //     } else {
      //       if (value < 18) {
      //         callback(new Error("必须年满18岁"));
      //       } else {
      //         callback();
      //       }
      //     }
      //   }, 1000);
    };
    var validatePass = (rule, value, callback) => {
      //let reg = /^[a-z,0-9]{10,}$/; //Unic
      //let reg = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~])[a-zA-Z0-9!"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~]{10,32}$/;  //
      let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~])[a-zA-Z0-9!"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~]{10,32}$/; //必须有个大写
      if (value === "") {
        callback(new Error("请输入密码"));
      }
      if (!reg.test(value)) {
        callback(
          new Error("密码由大小写字母、数字、特殊字符组成，长度至少10位，不超过32位")
        );
      } else {
        // if (this.ruleForm2.checkPass !== "") {
        //   this.$refs.ruleForm2.validateField("checkPass");
        // }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~])[a-zA-Z0-9!"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~]{10,32}$/; //必须有个大写
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm2.confirmNewPwd) {
        callback(new Error("两次输入密码不一致!"));
      } else if (!reg.test(value)) {
        callback(new Error("密码由大小写字母、数字、特殊字符组成，长度至少10位，不超过32位")
      );
      } else {
        callback();
      }
    };
    return {
      rules: {
        newPwd: [{ trigger: "blur" }],
        confirmNewPwd: [{ trigger: "blur" }],
        //   age: [
        //     { validator: checkAge, trigger: 'blur' }
        //   ]
      },
      rules2: {
        newPwd: [
          {
            required: true,
            validator: validatePass,
            trigger: "blur",

          },
        ],
        confirmNewPwd: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
        oldPwd: [
          { required: true, trigger: "blur", message: "原密码不能为空" },
        ],
        // oldPwd: [{ required: true, validator: checkOldPwd, trigger: "blur" }],
      },
      ruleForm2: {
        oldPwd: "",
        newPwd: "",
        confirmNewPwd: "",
      },
      paramValue: "", //后台返回的 是否需要验证密码的正则表达式
      checkPwd: true,
      currentUser: this.$store.state.user.currentUser,
      password: {},
      showChange: false,
      showClose: false,
      currenRoute: {
        firstName: "",
        secName: "",
        secPath: "",
        third: "",
        thirdPath: "",
      },
      visible: false,
      top: 0,
      left: 0,
      linkMan: "",

      animate: false,
      marqueeList: [],
      clearTime: null,
      newsTotal: 0,
      remark: "用户密码规则，必须包含大小写字母、数字、特殊字符，长度至少10位。",
      isShowDdyb: this.$isShowDdyb,
      loginInfor: {
        userName: '',
        password: '',
        remember: false
      },
      src:
        this.$isShowDdyb.indexOf("yb") > -1
          ? require("../../assets/img/logo4.png")
          : require("../../assets/img/logo.png"),
    };
  },
  mounted() {
    this.linkMan = localStorage.getItem("portWebInfo");
    this.loginInfor = JSON.parse(localStorage.getItem("loginForm"));
    console.log("loginInfor", this.loginInfor);
    console.log("isShowDdyb", this.isShowDdyb);
    this.filterBread(this.$route);
    this.addViewTags(); // 页面显示
    this.intervalMassage();
    this.checkUser(); //检测 用户密码是否 过于简单
  },
  computed: {
    cachedViews() {
      console.log("标签页 cachedViews",this.$store.state.tagsView.cachedViews)
      return this.$store.state.tagsView.cachedViews;
    },
    menuIsCollapse() {
      return this.$store.getters.menuIsCollapse;
    },
    messageList() {
      return this.$store.getters.messageList;
    },
  },
  watch: {
    $route(newVal) {
      this.currenRoute = {
        firstName: "",
        secName: "",
        secPath: "",
        third: "",
        thirdPath: "",
      };
      if (newVal) {
        this.filterBread(newVal);
      }
      this.addViewTags();
      this.moveToCurrentTag();
    },
    visible(value) {
      if (value) {
        document.body.addEventListener("click", this.closeMenu);
      } else {
        document.body.removeEventListener("click", this.closeMenu);
      }
    },
    messageList(curVal, oldVal) {
      //这里的curVal就是需要监听的值
      this.marqueeList = curVal.list;
      this.newsTotal = curVal.notReadNum;
    },
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    async checkUser() {

      //console.log("checkUser");
      let param = {
        paramCode: "PWDREG",
      };
      let res = await parametersCode(param);
	    let regSring = null;

      if (res && res.data && res.data.paramValue) {
         console.log("checkUser res",res)
         regSring = res.data.paramValue; 
        //this.remark = res.data.remark;
        let reg = new RegExp(regSring);
        if (regSring) {

          if (reg.test(this.loginInfor.password)) {
            console.log("验证 密码 yes");
          } else {
            console.log("验证 密码 no");
            this.$message({
              message: "警告,密码过于简单请修改密码",
              type: "warning",
              duration: 3000,
            });
            this.showChange = true;
            this.showClose = false;
          }

        }

      }
      // if(!isEmpty(this.loginInfor.password)){
      //       //规则说明：1 表示必须包含至少一个字母   2 表示必须包含至少一个数字  3 表示必须包含至少一个特殊字符 4 表示密码由大小写字母、数字和特殊字符组成，长度在10到32之间

      //       let reg = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~])[a-zA-Z0-9!"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~]{10,32}$/;   //


      //       let b = reg.test(this.loginInfor.password);
      //       console.log("验证 b", b);

      //       if (reg.test(this.loginInfor.password)) {
      //         console.log("验证 yes");
      //       } else {
      //         console.log("验证 no");
      //         this.$message({
      //           message: "警告,密码过于简单请修改密码",
      //           type: "warning",
      //           duration: 3000,
      //         });
      //         this.showChange = true;
      //         //this.showClose = false;
      //       }			

      // }



    },
    modelOpenHandle(ref, bull, row) {
      this.component = ref;
      this.$nextTick(() => {
        this.$refs.newsDetail.dialogForm = true;
        bull
          ? (this.$refs.newsDetail.isEdit = true)
          : (this.$refs.newsDetail.isEdit = false);
        if (row) {
          this.$refs.newsDetail.loadData(row);
        }
      });
    },
    intervalMassage() {
      let that = this;
      this.getmessage();
      window.setInterval(this.getmessage, 1000 * 60 * 5);
    },
    getmessage() {
      if (this.clearTime) {
        window.clearInterval(this.clearTime);
      }
      getRollMessage().then((res) => {
        this.$store.commit("SET_MESSAGE_LIST", res.data);
        this.marqueeList = res.data.list;
        this.newsTotal = res.data.notReadNum;
      });
      this.clearTime = window.setInterval(this.showMarquee, 3000);
    },
    showMarquee: function () {
      this.animate = true;
      setTimeout(() => {
        this.marqueeList.push(this.marqueeList[0]);
        this.marqueeList.shift();
        this.animate = false;
      }, 500);
    },
    goPXzl() {
      setLinkhis().then((res) => {
        var a = document.createElement("a");
        var href =
          this.$isShowDdyb.indexOf("yb") > -1
            ? "https://cqbykj.yuque.com/books/share/5ea9b7d2-a445-4c33-82e2-b2af34ef5930?#"
            : "https://cqbykj.yuque.com/books/share/857d0a5d-8125-49b4-8797-276e2dda24ac?#";
        a.setAttribute("href", href);
        a.setAttribute("target", "_blank");
        a.setAttribute("id", "startTelMedicine");
        // 防止反复添加
        if (document.getElementById("startTelMedicine")) {
          document.body.removeChild(
            document.getElementById("startTelMedicine")
          );
        }
        document.body.appendChild(a);
        a.click();
      });
    },
    generateRoute() {
      if (this.$route.name) {
        return this.$route;
      }
      return false;
    },
    addViewTags() {
      const route = this.generateRoute();
      if (!route) {
        return false;
      }
      this.$store.dispatch("addVisitedViews", route);
    },
    filterBread(newVal) {
      let a = newVal.fullPath.split("/");
      if (newVal.path.indexOf("Home") !== -1) {
        this.currenRoute.firstName = "平台管理";
        if (newVal.path.indexOf("SystemS") !== -1) {
          this.currenRoute.secName = "系统管理工作台";
          this.currenRoute.secPath = "/Home/SystemS";
        } else if (newVal.path.indexOf("SystemBase") !== -1) {
          this.currenRoute.secName = "基础管理工作台";
          this.currenRoute.secPath = "/Home/SystemBase";
        }
      } else if (newVal.path.indexOf("business") !== -1) {
        this.currenRoute.firstName = "商务管理";
        this.currenRoute.secName = "商务管理工作台";
        this.currenRoute.secPath = "/business/busPla";
      } else if (newVal.path.indexOf("work") !== -1) {
        this.currenRoute.firstName = "现场作业管理";
        if (newVal.path.indexOf("gatePanel") !== -1) {
          this.currenRoute.secName = "铁路道闸工作台";
          this.currenRoute.secPath = "/work/gatePanel";
        } else if (newVal.path.indexOf("JobPlan") !== -1) {
          this.currenRoute.secName = "铁路作业计划管理";
          this.currenRoute.secPath = "/work/JobPlan";
        } else if (newVal.path.indexOf("containerJob") !== -1) {
          this.currenRoute.secName = "铁路集装箱作业台";
          this.currenRoute.secPath = "/work/containerJob";
        } else if (newVal.path.indexOf("yardPlan") !== -1) {
          this.currenRoute.secName = "堆场策划管理";
          this.currenRoute.secPath = "/work/yardPlan";
        }
      }
      if (a.length >= 4) {
        this.currenRoute.third = newVal.name;
        this.currenRoute.thirdPath = newVal.fullPath;
      }
      // console.log(55,this.currenRoute)
    },
    logout() {
      
      // this.$router.replace({
      //     path: "/Login",
      //   }); // 跳转路由

      // localStorage.clear();
      // location.reload();
      // this.$router.push('/Login')
      out().then((res) => {
        if(res){
          console.log("out res",res)
          let code = res.code
          localStorage.clear();
          this.$router.push('/Login')
          location.reload();
        }
      });
    },
    changePwd() {
      this.showChange = true;
      this.showClose = true;
    },
    submitPwd() {

      //let reg = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~])[a-zA-Z0-9!"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~]{10,32}$/;
      let reg = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!@#$%^&*-+.]).{10,}$/;
      if (reg.test(this.ruleForm2.newPwd)) {
        console.log("验证 yes");
      } else {
        console.log("验证 no");
        this.$message({
          message: "密码由大小写字母、数字、特殊字符组成，长度至少10位，不超过32位",
          type: "error",
          duration: 3000,
        });

        return
      }
      if (this.ruleForm2.newPwd === this.ruleForm2.confirmNewPwd) {
        updataPwd(this.ruleForm2).then((res) => {
          this.$message({
            message: "修改密码成功",
            type: "success",
            duration: 2000,
          });
          this.ruleForm2.password = this.ruleForm2.newPwd;
          localStorage.setItem("loginForm", JSON.stringify(this.loginForm));
          this.cancel();
        });
      } else {
        this.$message({
          message: "两次输入密码不一致",
          type: "warning",
          duration: 2000,
        });
      }
    },
    cancel() {
      this.password = {};
      this.showChange = false;
    },
    // 卡片
    isActive(route) {
      let id = this.$route.params.id;
      if (id) {
        let arr = this.$route.path.split(id);
        let str = arr[0];
        return route.path.indexOf(str) > -1;
      } else {
        return route.path === this.$route.path;
      }
    },
    moveToCurrentTag() {
      const tags = this.$refs.tag;
      this.$nextTick(() => {
        for (const tag of tags) {
          if (tag.to === this.$route.path) {
            this.$refs.scrollPane.moveToTarget(tag.$el);
            break;
          }
        }
      });
    },
    closeSelectedTag(view) {
      this.$store.dispatch("delVisitedViews", view).then((views) => {
        if (this.isActive(view)) {
          const latestView = views.slice(-1)[0];
          if (latestView) {
            this.$router.push(latestView.path);
          } else {
            this.$router.push("/");
          }
        }
      });
    },
    closeOthersTags() {
      this.$router.push(this.selectedTag.path);
      this.$store.dispatch("delOthersViews", this.selectedTag).then(() => {
        this.moveToCurrentTag();
      });
    },
    closeAllTags() {
      this.$store.dispatch("delAllViews");
      this.$router.push("/first");
    },
    openMenu(tag, e) {
      this.visible = true;
      this.selectedTag = tag;
      this.left = e.clientX;
      this.top = e.clientY - 58;
    },
    closeSelectedTag(view) {
      this.$store.dispatch("delVisitedViews", view).then((views) => {
        if (this.isActive(view)) {
          const latestView = views.slice(-1)[0];
          if (latestView) {
            this.$router.push(latestView.path);
          } else {
            this.$router.push("/first");
          }
        }
      });
    },
    closeMenu() {
      this.visible = false;
    },
    downloadAnd() {
      const { href } = this.$router.resolve({
        name: "android",
      });
      window.open(href, "_blank");
      // this.$router.push('/android')
    },
    handleRouterPush(val) {
      this.$store.commit("ADD_CACHED_VIEWS", val);
      this.$router.push(val.path);
    },
  },
};
</script>

<style scoped lang="scss">
/deep/ .el-dialog__headerbtn {
  top: 10px;
}

// /deep/ .el-dialog__close{
//   margin-top: -20px;
// }

.changePwdScrb {
  float: left;
  clear: both;
  display: block;
  width: 100%;
  background: #fdfbda;
  color: #333;
  font-size: 12px;
  padding: 10px 10px 10px 10px;
  margin: 0 0 30px 0;
}

.roll-class {
  cursor: pointer;
  color: #f56c6c;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 220px;
  display: inline-block;
}

#appHeader {
  position: fixed;
  top: 0;
  right: 0;
  // width: calc(100% - 200px);
  width: 100%;
  z-index: 199;
}

.appHeader {
  width: 100%;
  height: 60px;
  line-height: 20px;
  box-shadow: 0 1px 5px 0 rgba(0, 34, 77, 0.08);
  margin: 0px;
  // padding: 18px 15px;
  background-image: linear-gradient(to right, #696aee, #5872ec);
  color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.systemName {
  font-size: 28px;
  line-height: 28px;
  color: #fff;
}

.userCss {
  color: #fff;
}

.right-info {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .el-dropdown {
    margin: 0px 15px;
    cursor: pointer;
    color: #fff;

    .title {
      font-size: 16px;
      line-height: 16px;

      img {
        vertical-align: bottom;
        padding: 0 6px;
      }
    }
  }
}

.pwdFoot {
  margin: 0 auto;
  text-align: right;
}

// .history {
//     width: 100%;
//     background: #fff;
//     white-space: nowrap;
//     height: 34px;
//     border-bottom: 1px solid #d8dce5;
// }
.tags-view-container {
  float: right;

  .tags-view-wrapper {
    background: #fff;
    height: 34px;
    border-bottom: 1px solid #d8dce5;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);

    // overflow-x: auto;
    .tags-view-item {
      display: inline-block;
      position: relative;
      height: 26px;
      line-height: 26px;
      border: 1px solid #d8dce5;
      color: #495060;
      background: #fff;
      padding: 0 8px;
      font-size: 12px;
      margin-left: 5px;
      margin-top: 4px;

      &:first-of-type {
        margin-left: 15px;
      }

      &.active {
        background-color: #409eff;
        color: #fff;
        border-color: #409eff;

        &::before {
          content: "";
          background: #fff;
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          position: relative;
          margin-right: 2px;
        }
      }
    }
  }

  .contextmenu {
    margin: 0;
    background: #fff;
    z-index: 100;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);

    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;

      &:hover {
        background: #eee;
      }
    }
  }
}

// .tags-view-wrapper::-webkit-scrollbar {
//     display: none;
// }

.tags-l {
  width: calc(100% - 64px);
}

.tags-r {
  width: calc(100% - 200px);
}

.tags-view-item {
  display: inline-block;
  position: relative;
  height: 26px;
  line-height: 26px;
  border: 1px solid #d8dce5;
  color: #495060;
  background: #fff;
  padding: 0 8px;
  font-size: 12px;
  margin-left: 5px;
  margin-top: 4px;
  text-decoration: none;
}

.shou {
  cursor: pointer;
}

.header-userInfo {
  border-right: 1px solid #999;
  box-shadow: 2px 0px 0px #ccc;
  font-size: 16px;
  padding-right: 10px;
}

.logo-pic {
  height: 46px;
  padding-left: 10px;
}

.marquee {
  width: 250px;

  height: 30px;

  align-items: center;

  color: #fff;

  display: flex;

  box-sizing: border-box;

  overflow: hidden;
}

.marquee_box {
  display: block;

  position: relative;

  width: 96%;

  height: 30px;

  overflow: hidden;
}

.marquee_list {
  display: block;

  position: absolute;

  top: 0;

  left: 0;
}

.marquee_top {
  transition: all 0.5s;

  margin-top: -30px;
}

.marquee_list li {
  height: 30px;

  line-height: 30px;

  font-size: 14px;

  padding-left: 20px;
  text-decoration: underline;
}

.marquee_list li span {
  padding: 0 2px;
}

.pic-notic {
  display: inline-block;
  width: 30px;
  vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/appHeader.vue